
    import './styles.scoped.css';
    export default {
  "content-enter": "awsui_content-enter_gwq0h_mcjcg_97",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_gwq0h_mcjcg_1",
  "trigger-expanded": "awsui_trigger-expanded_gwq0h_mcjcg_119",
  "icon": "awsui_icon_gwq0h_mcjcg_133",
  "root": "awsui_root_gwq0h_mcjcg_151",
  "expand-button": "awsui_expand-button_gwq0h_mcjcg_189",
  "expanded": "awsui_expanded_gwq0h_mcjcg_196",
  "icon-container": "awsui_icon-container_gwq0h_mcjcg_200",
  "icon-container-container": "awsui_icon-container-container_gwq0h_mcjcg_205",
  "wrapper": "awsui_wrapper_gwq0h_mcjcg_209",
  "wrapper-default": "awsui_wrapper-default_gwq0h_mcjcg_216",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_mcjcg_216",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_mcjcg_219",
  "wrapper-container": "awsui_wrapper-container_gwq0h_mcjcg_222",
  "wrapper-compact": "awsui_wrapper-compact_gwq0h_mcjcg_226",
  "header-deprecated": "awsui_header-deprecated_gwq0h_mcjcg_240",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_mcjcg_264",
  "header": "awsui_header_gwq0h_mcjcg_240",
  "header-wrapper": "awsui_header-wrapper_gwq0h_mcjcg_283",
  "header-actions-wrapper": "awsui_header-actions-wrapper_gwq0h_mcjcg_293",
  "header-button": "awsui_header-button_gwq0h_mcjcg_298",
  "header-container-button": "awsui_header-container-button_gwq0h_mcjcg_298",
  "header-container": "awsui_header-container_gwq0h_mcjcg_298",
  "header-navigation": "awsui_header-navigation_gwq0h_mcjcg_330",
  "header-text": "awsui_header-text_gwq0h_mcjcg_362",
  "content": "awsui_content_gwq0h_mcjcg_97",
  "content-default": "awsui_content-default_gwq0h_mcjcg_369",
  "content-footer": "awsui_content-footer_gwq0h_mcjcg_372",
  "content-expanded": "awsui_content-expanded_gwq0h_mcjcg_375",
  "content-compact": "awsui_content-compact_gwq0h_mcjcg_378",
  "focusable": "awsui_focusable_gwq0h_mcjcg_382",
  "click-target": "awsui_click-target_gwq0h_mcjcg_393"
};
  